<div class="card floating shadow-lg">
    <div class="card-body">
        <h3 class="card-title main-title">Transaction History</h3>


        <table #table mat-table [dataSource]="dsTransactions" matSort multiTemplateDataRows class="table-striped full-width">

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Process Date </th>
                <td mat-cell *matCellDef="let element" class="cursor">
                    {{element.processDate | date: 'longDate'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="receiptNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Receipt Number </th>
                <td mat-cell *matCellDef="let element" class="cursor"> {{element.receiptFullString}} </td>
            </ng-container>

            
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                <td mat-cell *matCellDef="let element" class="cursor text-right">
                    <a class="">
                        <i class="fas fa-plus" (click)="expandedElement = expandedElement === element ? null : element"></i>
                    </a>
                </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="transactionsColumns.length">
                    <div class="example-element-detail"
                        [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">

                        <ul class="list-group list-group-flush full-width">
                            <li class="list-group-item">
                                <div class="row">
                                    <div class="col-6">
                                        <b>Items</b>
                                    </div>
                                    <div class="col-3">
                                        <b>Invoice No.</b>
                                    </div>
                                    <div class="col-3 text-right">
                                        <b>Amount</b>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item" *ngFor="let item of element.pays; let i= index">
                                <div class="row">
                                    <div class="col-6">
                                        {{item.itemName}}
                                    </div>
                                    <div class="col-3">
                                        {{item.invoiceNo}}
                                    </div>
                                    <div class="col-3 text-right">
                                        <span *ngIf="app.config!=null" [innerHTML]="app.config.currencySymbol"></span>{{item.amount | number: '1.2'}}
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item">
                                <div class="row">
                                    <div class="col-6">
                                        <b>Payment Type</b>
                                    </div>
                                    <div class="col-3">
                                        <b>Gift Voucher Number</b>
                                    </div>
                                    <div class="col-3 text-right">
                                        <b>Amount</b>
                                    </div>
                                </div>
                            </li>
                            <li class="list-group-item" *ngFor="let item of element.paymentDetails; let i= index">
                                <div class="row">
                                    <div class="col-6">
                                        {{item.paymentTypeName}}
                                    </div>
                                    <div class="col-3">
                                        {{item.giftVoucherNumber}}
                                    </div>
                                    <div class="col-3 text-right">
                                        <span *ngIf="app.config!=null" [innerHTML]="app.config.currencySymbol"></span>{{item.amount | number: '1.2'}}
                                    </div>
                                </div>
                            </li>
                        </ul>

                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="transactionsColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: transactionsColumns;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                >
                <!-- (click)="expandedElement = expandedElement === element ? null : element" -->
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>

            <ng-container matColumnDef="loading">
                <td mat-footer-cell *matFooterCellDef colspan="4">
                    <i class="fas fa-circle-notch fa-spin"></i>&nbsp;Loading data...
                </td>
            </ng-container>

            <ng-container matColumnDef="noData">
                <td mat-footer-cell *matFooterCellDef colspan="4">
                    No transaction record found.
                </td>
            </ng-container>

            <ng-container matColumnDef="totaRecords">
                <td mat-footer-cell *matFooterCellDef colspan="4">
                    <mat-paginator [pageSize]="10" showFirstLastButtons></mat-paginator>
                </td>
            </ng-container>

            <tr mat-footer-row *matFooterRowDef="['loading']" [ngClass]="{'d-none':dsTransactions != null}">
            </tr>

            <tr mat-footer-row *matFooterRowDef="['noData']"
                [ngClass]="{'d-none':!(dsTransactions != null && dsTransactions.data.length == 0)}">
            </tr>

            <tr mat-footer-row *matFooterRowDef="['totaRecords']"
                [ngClass]="{'d-none':!(dsTransactions != null && dsTransactions.data.length > 10)}">
            </tr>

        </table>
    </div>
</div>
<br>